// @flow

import PopupModalButton from '../components/PopupModalButton';
import { isSmallScreen } from '../classes/Helpers';
import EventNames from '../constants/EventNames';
import Notifications from '../constants/Notifications';

export default class CartNotificationButton extends PopupModalButton {
  /**
   * Initialize the component
   *
   * @param pEl
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    if (isSmallScreen()) {
      this.removeEventListener(EventNames.CLICK, this.clickHandler);
    }
  }
}
